<template>
    <div class="lesson-item">
        <div class="lesson-tasks">
            <div class="lesson-menu">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" text-color="#929292"
                    active-text-color="#666" @select="handleSelect">
                    <el-menu-item v-for="menu in menus" :key="menu.id" :index="menu.id">{{menu.name}}</el-menu-item>
                </el-menu>
                <div class="lesson-menu-describe" :class="`describe-${activeIndex}`" v-if="canEdit">
                    <el-button type="text" icon="el-icon-edit" @click="addHomework">发布{{menus[activeIndex].name}}
                    </el-button>
                </div>
            </div>
            <is-empty class="notices-list" :show="list.length > 0" message="暂无作业~">
                <div class="lesson-list">
                    <el-card class="box-card" shadow="hover" v-for="(item,index) in list" :key="item.uid">
                        <div slot="header" class="clearfix">
                            <span class="lesson-title">
                                <span v-text="item.name"/>
                            </span>
                            <div class="action-btns-right" v-if="canEdit">
                                <el-dropdown trigger="click" @command="handleCommand($event, item ,index)">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-more el-icon--right"/>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item icon="el-icon-edit-outline" command="update">编辑作业</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-view" command="see">作业详情</el-dropdown-item>
                                        <!-- <el-dropdown-item icon="el-icon-tickets" command="saveTo">保存到...</el-dropdown-item> -->
                                        <el-dropdown-item icon="el-icon-delete" command="remove">删除</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-s-cooperation" command="pack" v-if="setDept" :disabled="item.packFlag || item.packStatus === 1" >打包</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-download" command="download" v-if="setDept" :disabled="!item.packFileUrl">下载</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="lesson-body">
                            <div class="info">
                                <!-- <p class="word p" v-html="item.describe"></p> -->
                                <el-button v-if="item.annexUid" type="success" size="mini" style="margin-bottom:10px" @click="handLoad(item.annexUid)">点击下载作业附件</el-button>
                                <div class="time">
                                    <span class="item">
                                        <b>截止日期：</b>
                                        {{ item.cutoffTime }}
                                    </span>
                                  <span class="item group-name" v-if="activeIndex === 1" v-text="item.groupName"/>
                                </div>
                            </div>
                            <div class="action">
                                <div class="total-cont" v-if="canEdit" style="overflow:hidden;margin-bottom:5px">
                                    <p class="score"
                                        @click="$router.push(`/lesson/${$route.params.uid}/task/${item.uid}`)">
                                      <a v-text="item.markCount"/>
                                        <a class="green" v-if="activeIndex === 0">已批</a>
                                        <a class="green" v-else>已批(组)</a>
                                    </p>
                                    <p class="score"
                                        @click="$router.push(`/lesson/${$route.params.uid}/task/${item.uid}`)">
                                      <a v-text="item.noMarkCount"/>
                                        <a class="grey" v-if="activeIndex === 0">未批</a>
                                        <a class="grey" v-else>未批(组)</a>
                                    </p>
                                    <p class="score" @click="$router.push(`/lesson/${$route.params.uid}/task/${item.uid}`)">
                                      <a v-text="item.noSubmitCount<0 ? 0 : item.noSubmitCount"/>
                                        <a class="red" v-if="activeIndex === 0">未交</a>
                                        <a class="red" v-else>未交(组)</a>
                                    </p>
                                </div>
                                <template v-if="canStudy">
                                    <div style="text-align:center">
                                        <el-button type="primary" size="small" @click="handleUp(item.uid)"
                                            :disabled="item.status===2">上传作业</el-button>
                                        <el-button type="primary" size="small" @click="handlecheckReprot(item.uid)" :disabled="!item.isSubmit">查看批阅
                                        </el-button>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </el-card>
                    <el-pagination style="margin-top:15px" background prev-text="上一页" next-text="下一页"
                        layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page"
                        :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handlePageChange"
                        hide-on-single-page>
                    </el-pagination>
                </div>
            </is-empty>
            <el-dialog  :title="dialogTitle" :visible.sync="open">
                <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                    <el-form-item label="作业名称" prop="taskName">
                      <el-input v-model="form.taskName" placeholder="请输入作业名称"/>
                    </el-form-item>
                    <template v-if="form.isGroup === '1'">
                        <el-form-item label="选择分组" prop="groupUid">
                            <el-select v-model="form.groupUid" placeholder="请选择分组">
                              <el-option v-for="group in groupList" :key="group.uid" :label="group.name"
                                         :value="group.uid"/>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-form-item label="满分值" prop="totalScore">
                      <el-input-number v-model="form.totalScore" :min="1" label="请输入满分值"/>
                    </el-form-item>
                    <el-form-item label="截止时间" prop="cutoffTime">
                      <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择截止时间"
                                      v-model="form.cutoffTime"/>
                    </el-form-item>
                    <el-form-item label="作业描述">
                        <!-- <el-input v-model="form.taskDescribe" type="textarea" :rows="3" placeholder="请输入描述"></el-input> -->
                        <div class="task-editor">
                            <editor ref="editor" class="task-editor" :content="form.taskDescribe" @onblur="onblur($event, 'taskDescribe')" @onchange="handleChange" />
                        </div>
                    </el-form-item>
                    <el-form-item label="上传附件">
                        <el-upload ref="upload" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList" :http-request="httpRequest" :on-remove="removeFile">
                          <i class="el-icon-plus"/>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="open = false">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { open_blank } from '@/utils/router'
import { mapGetters } from 'vuex'
import { queryGroupList } from '@/api/lab/group'
import { addTask, removeTask, updateTask, getTaskList, checkTask, getMyTask } from '@/api/lab/tasks'
import { uploadFile,getFileInfoByUid ,packTaskFile} from '@/api/file'
import editor from '@/components/common/editor'

import isEmpty from '@/components/common/is-empty'
export default {
    props: {
        canEdit: {
            type: Boolean
        },
        canStudy: {
            type: Boolean
        }
    },
    data () {
        return {
            fileList:[],
            dialogTitle: "发布作业",
            open: false,
            form: {},
            rules: {
                taskName: [
                    { required: true, message: "请输入作业名称", trigger: "blur" }
                ],
                totalScore: [
                    { required: true, message: "请输入满分值", trigger: "blur" }
                ],
                groupUid: [
                    { required: true, message: "请选择分组", trigger: "blur" }
                ],
                cutoffTime: [
                    { required: true, message: "请选择截止时间", trigger: "blur" }
                ]
            },
            activeIndex: '0', // 0 个人作业   1 小组作业
            menus: [
                { id: '0', name: '个人作业' },
                // { id: '1', name: '小组作业' }
            ],
            list: [],
            groupList: [], // 课堂分组列表
            page: {
                page: 1,
                limit: 10,
                total: 0
            }
        }
    },
    components: {
        isEmpty,
        editor
    },
    created () {
        this.init()
    },
    mounted () {
        this.taskTimer = setInterval(this.getTaskList, 30000);
    },
    beforeDestroy () {
        clearInterval(this.taskTimer);
    },
    computed: {
        ...mapGetters(['userInfo']),
        time () {
            let t = new Date()
            let Y = t.getFullYear()
            let M = t.getMonth() + 1
            let D = t.getDate()
            return new Date(`${Y}-${M}-${D} 00:00:00`).getTime() + 30 * 24 * 3600 * 1000
        },
        setDept(){
          // TODO 是否有打包、下载功能
            // const { roles } = this.userInfo
            // return roles.indexOf(6) > -1
          return false
        },
    },
    methods: {
        init () {
            this.getTaskList()
            // this.getGroupList()
        },
        handleChange (txt) {
            this.$set(this.form, 'taskDescribe', txt)
        },
        onblur (info, key) {
            this.$set(this.form, key, info);
        },
        removeFile () {
            this.fileList = []
        },
        httpRequest (param) {
            let fileObj = param.file
            if((Number(fileObj.size)/1024/1024).toFixed(2)>20){
                this.$message.warning('上传文件大小不能超过20M!')
                this.$refs.upload.clearFiles()
            }else {
                this.uploadFile(fileObj)
                this.$refs.upload.clearFiles()
            }
        },
        handLoad(uid){
            getFileInfoByUid(uid).then(res=>{
                this.download(res.name, res.originalPath)
            })
        },
        download(name,url){
            const ele = document.createElement('a');
            ele.setAttribute("target", "_blank")
            ele.setAttribute('href', this.$options.filters['filterUrl'](url)+"?response-content-type=application/octet-stream");
            ele.setAttribute('download',name);
            ele.style.display = 'none';
            document.body.appendChild(ele);
            ele.click();
            document.body.removeChild(ele);
        },
        // 文件或者图片上传
        uploadFile (files) {
            // 作业附件
            uploadFile(files, `lesson/${this.form.lessonUid}/tasks/annex/`).then(res => {
                this.$set(this.form, 'annexUid', res.uid)
                if (this.fileList.length > 0) {
                    this.fileList.splice(0, 1, res)
                } else {
                    this.fileList.push(res)
                }
            })
        },
        handlePageChange (page) {
            this.$set(this.page, "page", page);
            this.getTaskList();
        },
        /**
		 * 学生查看自己的报告
		 */
        handlecheckReprot (uid) {
            getMyTask(uid).then(res => {
                open_blank({
                    name: 'lessonTaskMarking',
                    params: { uid: res }
                })
            })
        },
        handleSelect (key, keyPath) {
            if (this.activeIndex != keyPath[0]) {
                this.activeIndex = keyPath[0]
                this.getTaskList()
            }
        },
        addHomework () {
            this.form = {
                // groupUid: this.groupList[0].uid || null,
                // 作业类型 0 个人作业  1 小组作业
                isGroup: this.activeIndex,
                lessonUid: this.$route.params.uid,
                totalScore: 100,
                cutoffTime: new Date(this.time).format("yyyy-MM-dd hh:mm:ss")
            };
            this.dialogTitle = this.activeIndex == '0' ? '发布个人作业' : '发布小组作业';
            this.$nextTick(() => {
                this.$refs['editor'].changeTxt(this.form.taskDescribe)
            })
            this.open = true;
            this.fileList = []
        },
        submit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.uid) {
                        this.updateTask(this.form)
                    } else {
                        this.addTask(this.form)
                    }
                } else {
                    return false
                }
            })
        },
        handleCommand (command, task , index) {
            if (command === 'update') {
                this.form = {
                    ...task,
                    taskName: task.name,
                    taskDescribe: task.describe,
                    isGroup: this.activeIndex
                }
                this.dialogTitle = this.activeIndex == '0' ? '编辑个人作业' : '编辑小组作业'
                this.$nextTick(() => {
                    this.$refs['editor'].changeTxt(task.describe)
                })
                this.open = true
            }
            if (command === 'remove') {
                this.removeTask(task.id)
            }
            if (command === 'see') {
                this.$router.push(`/task/${task.uid}/taskDetails`)
            }
            if(command === 'pack') {
                this.$set(this.list[index],'packFlag',true)
                this.$message.success('开始打包,请勿重复点击打包,稍后点击下载按钮即可!')
                packTaskFile(task.uid).then(()=>{})
            }
            if(command === 'download') {
                this.download(task.name,task.packFileUrl)
            }
        },
        addTask (task) {
            addTask(task).then(() => {
                this.onSuccess()
            })
        },
        removeTask (id) {
            this.$confirm('此操作将永久删除该作业, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeTask([id]).then(() => {
                    this.onSuccess()
                })
            }).catch(() => { })
        },
        updateTask (task) {
            updateTask(task).then(() => {
                this.onSuccess()
            })
        },
        getTaskList () {
            this.list = []
            const { page, limit } = this.page
            getTaskList(page, limit, {
                lessonUid: this.$route.params.uid,
                isGroup: this.activeIndex
            }).then(res => {
                this.list = res.list
                const { list, totalCount } = res
                this.$set(this.page, "total", totalCount);
                this.list = list
            })
        },
        getGroupList () {
            this.groupList = []
            const { page, limit } = this.page
            queryGroupList(page, limit, {
                lessonUid: this.$route.params.uid
            }).then(res => {
                const { list, totalCount } = res
                this.$set(this.page,  "total", totalCount)
                this.groupList = list
            })
        },
        checkTask (uid) {
            const lessonUid = this.$route.params.uid
            checkTask(uid).then(() => {
                this.$router.push(`/lesson/${lessonUid}/task/handup/` + uid);
            })
        },
        onSuccess () {
            this.form = {}
            this.open = false
            this.$message.success('操作成功')
            this.getTaskList()
        },
        handleUp (uid) {
            this.checkTask(uid)
        }
    }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/lesson-tasks.less');
</style>
<style lang="less">
.lesson-tasks{
    .task-editor{
        .w-e-text-container{
            height: 200px!important;
        }
    }
}
</style>
